import HuaweiError from '../../../../controllers/HuaweiErrors';
import { PlayResult } from '../../../../interfaces';
import { VodPlaybackOption } from '../../titles/types/playback-option';
import { PlayData, startSession } from '../api';
import { getMediaId } from './get-media';
import { handlePlayResult } from './handle-play-result';
import { client } from './huawei-client';

interface AuthorizationResponse {
  subscriptionKey: string;
  retcode: string;
}

export async function playHuaweiSvod(option: VodPlaybackOption, shouldStartSession: boolean): Promise<PlayData> {
  const mediaId = getMediaId(option);

  const auth = await client.post<AuthorizationResponse>('/EPG/JSON/Authorization', {
    businesstype: 1, // 1 = VOD
    contentid: option.platformTitleId,
    contenttype: 'VOD',
    mediaId: mediaId,
  });

  if (auth.retcode === HuaweiError.NO_ACCESS) {
    throw auth;
  }

  const data = await client.post<PlayResult>('/EPG/JSON/Play', {
    contentid: option.platformTitleId,
    playtype: 1,
    mediaid: mediaId,
    subscriptionKey: auth.subscriptionKey,
  });

  const result = handlePlayResult(data);

  let sessionId = 'N/A';

  if (shouldStartSession) {
    sessionId = await startSession({
      duration: 0,
      platformTitleId: option.platformTitleId,
      providerIdentifier: option.providerIdentifier,
    });
  }

  const trigger = result.triggers[0].getLicenseTrigger;

  return {
    status: true,
    platform: 'huawei',
    url: result.url,
    message: '',
    licenseUrl: trigger.licenseURL,
    token: trigger.customData,
    sessionId: sessionId,
    releasePid: '',
    account: '',
    mediaId: mediaId,
  };
}
